const REMEDIES = [
  {
    title: "Shani Mantra",
    desc: "Chant 'Om Sham Shanishcharaya Namah' 108 times daily, especially on Saturdays.",
  },
  {
    title: "Hanuman Chalisa",
    desc: "Recite on Tuesdays and Saturdays. Lord Hanuman is the most powerful protector against Shani's malefic effects.",
  },
  {
    title: "Saturday Donations",
    desc: "Donate black sesame seeds, mustard oil, iron utensils, and dark blankets to the needy on Saturdays.",
  },
  {
    title: "Feed Crows",
    desc: "Crows are Shani's vehicle. Feed them regularly as a simple daily remedy.",
  },
  {
    title: "Saturday Fasting",
    desc: "Observe a fast on Saturdays, consuming one meal after sunset.",
  },
  {
    title: "Shani Temple Visit",
    desc: "Visit a Shani temple on Saturdays and offer sesame oil (til tel) to the idol.",
  },
  {
    title: "Discipline & Service",
    desc: "Saturn rewards hard work, honesty, and service to elders. This is the most effective remedy.",
  },
];

export function SadeSatiRemedies() {
  return (
    <div className="card-sacred p-6 sm:p-8 mt-6">
      <h2
        className="text-[18px] font-bold mb-4"
        style={{
          fontFamily: "var(--font-pt-serif), PT Serif, Georgia, serif",
          color: "var(--ish-dark)",
        }}
      >
        Sade Sati Remedies (उपाय)
      </h2>
      <div className="space-y-3">
        {REMEDIES.map((remedy) => (
          <div
            key={remedy.title}
            className="flex gap-3 p-3 rounded-lg"
            style={{ backgroundColor: "rgba(0,0,0,0.02)" }}
          >
            <span className="text-lg shrink-0 mt-0.5" style={{ color: "var(--intent-brand-text)" }}>
              ♄
            </span>
            <div>
              <span className="text-body font-semibold" style={{ color: "var(--ish-dark)" }}>
                {remedy.title}
              </span>
              <p className="text-body-small mt-0.5" style={{ color: "var(--ish-text-muted)" }}>
                {remedy.desc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
